
import {
  Row,
  Col,
  Button,
  ButtonGroup,
}from 'react-bootstrap';

import {
  Label,
  Audio,
  ListView,
}from '../';

import { COLOR, MODES } from '../../const';

var React = require('react');
var Radium = require('radium');
var FontAwesome = require('react-fontawesome');
var HelperScripts = require('../../utils/HelperScripts.js');

class WordSearchAct extends React.Component {
  render() {
    return(
      <div>
        <Row>
          <ListView {...this.props}>
            {this.props.progressList.map(item => {
              return(
              <WordSearchItem
                key={item.word}
                item = {item}
                isCorrect = {item.isCorrect}
                {...this.props}
              />
            )})}
          </ListView>
        </Row>
      </div>
    )
  }
}

class WordSearchItem extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      options: [],
      width: '0',
      buttonGrpWidth: '0',
    };
  }

  componentDidMount(){
    //console.log(this.state.options.length);
    /*  Screen res  */
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    /*  ----------  */
    if (this.state.options.length === 0) {
      this.setOptions();
    }

  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {

    let posInfo = this.answerButtons.offsetWidth;
    console.log(this.answerButtons);

    this.setState({
      width: window.innerWidth,
      buttonGrpWidth: posInfo,
    });
  }

  setOptions = () => {
    const {item,progressList} = this.props;

    if (!item) return;

    //Split
    let arr = item.word.split('');
    //Letter pool
    let possible = "abcdefghijklmnopqrstuvwxyz";
    //Avoid repeated letters
    let re = new RegExp(`[${item.word}]`,"g");
    possible = possible.replace(re,'');
    console.log(possible);
    //Save options here
    let options = [{}]
    //Add each option
    for (var i = 0; i < MODES.WordSearch.extraLetters; i++) {

      let letter = possible.charAt(Math.floor(Math.random() * possible.length));

      options[i] = {
        letter: letter,
        wasChecked: false,
        isCorrect: false,
      }
    }

    //Shuffle random letters
    options = HelperScripts.ShuffleArray(options);

    let stIndex = Math.floor(Math.random() * (options.length));
    console.log(stIndex);
    //Add each letter at a random index
    for (var j = 0; j < arr.length; j++) {
      let newObj = {
        letter: arr[j],
        wasChecked: false,
        isCorrect: false,
      }
      options.splice(stIndex + j,0,newObj);
    }

    console.log(possible);
    //Assign
    this.setState({
      options: options,
    });
  }

  playAudio = () => {
    this.audio.onPlay();
  }

  handleAnswerClick = (option) => {
    const {item, wasChecked} = this.props;
    const {options} = this.state;
    //If its already checked, exit
    if (wasChecked) return;
    //If word contains letter and make sure we dont allow to repeat letters
    if (item.word.includes(option.letter) && options.filter(e => (e.letter === option.letter && e.wasChecked === true)).length < item.word.split(option.letter).length ){
      //Mark it as checked
      option.wasChecked = true;
      //is Right
      option.isCorrect = true;
    }else{
      //Mark it as checked
      option.wasChecked = true;
      //is wrong
      option.isCorrect = false;
    }

    const rightAnswersLen = options.filter(e => (item.word.includes(e.letter) && e.wasChecked && e.isCorrect)).length;
    const totalAnswerLen = options.filter(e => (item.word.includes(e.letter) && e.wasChecked)).length;
    const wordLen = item.word.length;

    //Check if Done
    if (rightAnswersLen >= wordLen){
      //Done right
      this.props.updateProgressList({
        word: this.props.item.word,
        isCorrect: true,
        wasChecked: true,
      })
    }else if (totalAnswerLen >= wordLen){
      //Done wrong
      this.props.updateProgressList({
        word: this.props.item.word,
        isCorrect: false,
        wasChecked: true,
      })
    }

    //Rerender
    this.forceUpdate();

  }

  render() {

    const {container, header, sentence, footer, button, check} = styles.item.base;
    const {container: containerCorr , sentence: sentenceCorr} = styles.item.correct;
    const {container: containerNorm , sentence: sentenceNorm} = styles.item.notChecked;

    const {item, mode, toggleAudio, isAudioPlaying, updateProgressList, isCorrect, setAudioFalse, id} = this.props;

    return (
      <Col
        xs={12}
        md={6}
        style={
          styles.item.base
        }
      >
        <div style={[container, isCorrect && containerCorr, !isCorrect && containerNorm]}>
          <div style={header}>
            <Label color="white" italic text={"Word Sound"}/>
            <Button
              bsStyle="success"
              bsSize="lg"
              //block
              onClick={this.playAudio}
              style={button}
               >
              <FontAwesome
                name="volume-up"
                inverse={true}
                size="lg"
              />
            </Button>
            <Label color="white" italic text={"Letters"}/>
          </div>
          <AnswerButtons
            options={this.state.options}
            handleAnswerClick={this.handleAnswerClick}
            currWidth={this.state.width}
            maxResW={500}
            ref={ (AnswerButtons) => this.answerButtons = AnswerButtons}
          />
          <div style={footer}>

            {isCorrect &&
              <FontAwesome
                name="check"
                inverse={true}
                size="3x"
                style={check}
              />
            }
          </div>
          <Audio
            mode={mode}
            item={item}
            onEndedCallback={(!isCorrect) ? this.onEndedCallback : null}
            isAudioPlaying={isAudioPlaying}
            toggleAudio={toggleAudio}
            setAudioFalse={setAudioFalse}
            ref={(Audio) => {this.audio = Audio;}}
          />
        </div>
      </Col>
      )
  }
}

let AnswerButtons = ({options = [], handleAnswerClick, currWidth, maxResW}) => {

  let id = 0;

  return(
    <ButtonGroup
      block={(currWidth <= maxResW) ? true : false}
      vertical={(currWidth <= maxResW) ? true : false}
      style={styles.buttonGroup}>
      {options.map(option => {

        let bsStyle, textStyle, buttonStyle;
        //Correct and checked
        if (option.isCorrect && option.wasChecked){
          textStyle = {...styles.item.correct.option};
          buttonStyle = {...styles.item.correct.optionBtn};
          bsStyle="success";
        //Incorrect and checked
        }else if (!option.isCorrect && option.wasChecked){
          textStyle = {...styles.item.incorrect.option};
          buttonStyle = {...styles.item.incorrect.optionBtn};
          bsStyle="danger";
        //Not checked
        }else{
          textStyle = {...styles.item.base.option};
          buttonStyle = {...styles.item.base.optionBtn};
          bsStyle="primary";
        }

        return(
          <Button
            key={id++}
            bsStyle={bsStyle}
            style={buttonStyle}
            bsSize="lg"
            onClick={() => handleAnswerClick(option)}
          >
            <div style={textStyle}>
              {option.letter}
            </div>
          </Button>
          )
        })}
    </ButtonGroup>
  )
}

WordSearchItem = Radium(WordSearchItem);
AnswerButtons = Radium(AnswerButtons);


const styles = {
  item: {
    base:{
      textAlign: 'center',
      marginBottom: '4rem',


      container: {
        borderRadius: '10px',
        minHeight: '300px',
      },
      header: {
        padding: '2rem',
      },
      sentence: {
        backgroundColor: COLOR.white,
        padding: '2rem 1rem',
        minHeight: '150px',

        text: {
          fontSize: '21px',
          fontWeight: '300',
        },
      },
      word: {
        color: COLOR.white,
        fontSize: '30px',
      },
      footer: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: '2rem',
      },
      button:{
        minWidth: '80%',
        marginBottom: '2rem',
      },
      check: {
        minWidth: '150px',
      },
      option: {
        color: COLOR.blue,
      },
      optionBtn: {
        backgroundColor: COLOR.white,
      },
    },
    notChecked: {
      container: {
        borderColor: COLOR.blue,
        backgroundColor: COLOR.blue,
      },
    },
    correct: {
      container: {
        borderColor: COLOR.green,
        backgroundColor: COLOR.green,
      },
      option: {
        color: COLOR.white,
      },
      optionBtn: {
        backgroundColor: COLOR.green,
      },
    },
    incorrect: {
      container: {
        borderColor: COLOR.red,
        backgroundColor: COLOR.red,
      },
      option: {
        color: COLOR.red,
      },
      optionBtn: {
        backgroundColor: COLOR.white,
      },
    }
  },
  buttonGroup:{

  }

}

export default Radium(WordSearchAct);



// WEBPACK FOOTER //
// ./src/comp/Activities/WordSearchAct.js